import React, { Component } from 'react'
import ProductIntro from '@common/ProductIntro'
import { PRODUCT_WECHAT_WEAPP } from '@constant'
import Api from '@api/system'
import liteApi from '@api/xiu_yan/liteAppManageApi'
import { Button, Modal, message } from 'hljd'
import { getDates } from '@common/ProductIntro/util'
import { goPayment } from '@util'

const confirm = Modal.confirm

export default class extends Component {
  constructor(props) {
    super(props)
    this.state = {
      merchant_weapp: {}
    }
  }

  componentDidMount() {
    this.getShopInfo()
  }

  getShopInfo = async () => {
    const { data, success } = await Api.shopInfo()
    if (success) {
      this.setState({ merchant_weapp: data.merchant_weapp || {} })
    }
  }

  freeOpenLiteApp = () => {
    confirm({
      title: '确认开通小程序?',
      onOk: async () => {
        let {
          data: { pay_success },
          success
        } = await liteApi.freeOpen({ kind: 3 })
        if (success && pay_success == 1) {
          message.success('开通成功！')
          window.location.href = '#/localMerchant/liteApp/manage'
          window.location.reload()
        }
      }
    })
  }

  render() {
    const {
      merchant_weapp: { type, status, server_end }
    } = this.state

    const end_time = (server_end || '').split(' ')[0]
    const isWillExpire = getDates(server_end)

    return (
      <ProductIntro
        id={PRODUCT_WECHAT_WEAPP}
        renderBtn={() => (
          <>
            {type == 0 || type == 2 ? (
              <Button type="primary" onClick={this.freeOpenLiteApp}>
                免费开通
              </Button>
            ) : status != 1 ? (
              <Button type="primary" onClick={this.freeOpenLiteApp}>
                免费开通
              </Button>
            ) : (
              <>
                <span>{`已开通 有效期至${end_time}`}</span>

                {isWillExpire && (
                  <span style={{ color: 'red' }}>(即将过期)</span>
                )}

                {isWillExpire && (
                  <Button type="primary" onClick={goPayment}>
                    立即续费
                  </Button>
                )}
              </>
            )}
          </>
        )}
      />
    )
  }
}
